import { render, staticRenderFns } from "./DiscountsSummary.vue?vue&type=template&id=33b1b74a&scoped=true"
import script from "./DiscountsSummary.vue?vue&type=script&lang=js"
export * from "./DiscountsSummary.vue?vue&type=script&lang=js"
import style0 from "./DiscountsSummary.vue?vue&type=style&index=0&id=33b1b74a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b1b74a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Filati\\filatiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33b1b74a')) {
      api.createRecord('33b1b74a', component.options)
    } else {
      api.reload('33b1b74a', component.options)
    }
    module.hot.accept("./DiscountsSummary.vue?vue&type=template&id=33b1b74a&scoped=true", function () {
      api.rerender('33b1b74a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/discounts/DiscountsSummary.vue"
export default component.exports